module.exports = __webpack_public_path__ + "img/l-bg-number.e067f357.png";